import React from 'react';
import { Link } from 'react-router-dom';
import { FiGift, FiDollarSign, FiShield, FiZap } from 'react-icons/fi';

const Home = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-blue-500 to-purple-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="text-center">
            <h1 className="text-5xl font-bold mb-6">
              Buy Gift Cards with Cryptocurrency
            </h1>
            <p className="text-xl mb-8 text-blue-100">
              Fast, secure, and simple. Use Bitcoin, Ethereum, Litecoin, or Dogecoin
            </p>
            <div className="flex justify-center space-x-4">
              <Link
                to="/catalog"
                className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition"
              >
                Browse Gift Cards
              </Link>
              <Link
                to="/register"
                className="bg-transparent border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition"
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="text-3xl font-bold text-center mb-12">Why Choose CryptoCashFast?</h2>
        <div className="grid md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <FiZap className="text-blue-600" size={32} />
            </div>
            <h3 className="text-xl font-semibold mb-2">Instant Delivery</h3>
            <p className="text-gray-600">Get your gift card codes immediately after payment confirmation</p>
          </div>

          <div className="text-center">
            <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <FiShield className="text-purple-600" size={32} />
            </div>
            <h3 className="text-xl font-semibold mb-2">Secure Payments</h3>
            <p className="text-gray-600">Blockchain-powered transactions for maximum security</p>
          </div>

          <div className="text-center">
            <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <FiDollarSign className="text-green-600" size={32} />
            </div>
            <h3 className="text-xl font-semibold mb-2">Best Rates</h3>
            <p className="text-gray-600">Competitive pricing with real-time crypto conversion</p>
          </div>

          <div className="text-center">
            <div className="bg-orange-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <FiGift className="text-orange-600" size={32} />
            </div>
            <h3 className="text-xl font-semibold mb-2">Wide Selection</h3>
            <p className="text-gray-600">Choose from hundreds of popular brands and retailers</p>
          </div>
        </div>
      </div>

      {/* Supported Cryptocurrencies */}
      <div className="bg-gray-100 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12">Supported Cryptocurrencies</h2>
          <div className="flex justify-center space-x-12">
            <div className="text-center">
              <div className="text-4xl mb-2">₿</div>
              <p className="font-semibold">Bitcoin</p>
            </div>
            <div className="text-center">
              <div className="text-4xl mb-2">Ξ</div>
              <p className="font-semibold">Ethereum</p>
            </div>
            <div className="text-center">
              <div className="text-4xl mb-2">Ł</div>
              <p className="font-semibold">Litecoin</p>
            </div>
            <div className="text-center">
              <div className="text-4xl mb-2">Ð</div>
              <p className="font-semibold">Dogecoin</p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
        <h2 className="text-3xl font-bold mb-4">Ready to Get Started?</h2>
        <p className="text-xl text-gray-600 mb-8">
          Join thousands of users buying gift cards with Bitcoin, Ethereum, Litecoin, and more
        </p>
        <Link
          to="/register"
          className="bg-primary text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-600 inline-block"
        >
          Create Your Free Account
        </Link>
      </div>

      {/* Merchant Portal Section */}
      <div className="bg-gradient-to-r from-purple-600 to-blue-500 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-4xl font-bold mb-4">Are You a Merchant?</h2>
            <p className="text-xl text-purple-100 mb-8 max-w-3xl mx-auto">
              Accept cryptocurrency payments and receive USD directly to your bank account. 
              Our merchant portal makes it easy to process crypto payments with instant conversion.
            </p>
            <div className="grid md:grid-cols-3 gap-8 mb-8 max-w-4xl mx-auto">
              <div className="text-center">
                <div className="text-5xl mb-2">₿</div>
                <h3 className="font-semibold mb-2">Accept Crypto</h3>
                <p className="text-sm text-purple-100">Bitcoin, Ethereum, Litecoin, Dogecoin</p>
              </div>
              <div className="text-center">
                <div className="text-5xl mb-2">💵</div>
                <h3 className="font-semibold mb-2">Get USD</h3>
                <p className="text-sm text-purple-100">Automatic conversion to USD</p>
              </div>
              <div className="text-center">
                <div className="text-5xl mb-2">🏦</div>
                <h3 className="font-semibold mb-2">Bank Deposit</h3>
                <p className="text-sm text-purple-100">Direct deposit in 2-3 days</p>
              </div>
            </div>
            <a
              href="https://merchant.cryptocashfast.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-purple-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition inline-block"
            >
              Visit Merchant Portal →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;

